// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { Binding } from '../../../cogo/renderpack/v1/binding.js';
import { DesignOp } from '../../../cogo/renderpack/v1/design-op.js';
import { Diagnostic } from '../../../cogo/renderpack/v1/diagnostic.js';
import { LayoutOp } from '../../../cogo/renderpack/v1/layout-op.js';
import { Node } from '../../../cogo/renderpack/v1/node.js';
import { PropOp } from '../../../cogo/renderpack/v1/prop-op.js';


export class RenderPack {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):RenderPack {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsRenderPack(bb:flatbuffers.ByteBuffer, obj?:RenderPack):RenderPack {
  return (obj || new RenderPack()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsRenderPack(bb:flatbuffers.ByteBuffer, obj?:RenderPack):RenderPack {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new RenderPack()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static bufferHasIdentifier(bb:flatbuffers.ByteBuffer):boolean {
  return bb.__has_identifier('RPK1');
}

schemaVersion():string|null
schemaVersion(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
schemaVersion(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

componentIds(index: number):string
componentIds(index: number,optionalEncoding:flatbuffers.Encoding):string|Uint8Array
componentIds(index: number,optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
}

componentIdsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

actionIds(index: number):string
actionIds(index: number,optionalEncoding:flatbuffers.Encoding):string|Uint8Array
actionIds(index: number,optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
}

actionIdsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

tokenIds(index: number):string
tokenIds(index: number,optionalEncoding:flatbuffers.Encoding):string|Uint8Array
tokenIds(index: number,optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
}

tokenIdsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

bindingIds(index: number):string
bindingIds(index: number,optionalEncoding:flatbuffers.Encoding):string|Uint8Array
bindingIds(index: number,optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
}

bindingIdsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

nodes(index: number, obj?:Node):Node|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new Node()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

nodesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

layoutOps(index: number, obj?:LayoutOp):LayoutOp|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new LayoutOp()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

layoutOpsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

designOps(index: number, obj?:DesignOp):DesignOp|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? (obj || new DesignOp()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

designOpsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

bindings(index: number, obj?:Binding):Binding|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new Binding()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

bindingsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

diagnostics(index: number, obj?:Diagnostic):Diagnostic|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? (obj || new Diagnostic()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

diagnosticsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

propOps(index: number, obj?:PropOp):PropOp|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? (obj || new PropOp()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

propOpsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startRenderPack(builder:flatbuffers.Builder) {
  builder.startObject(11);
}

static addSchemaVersion(builder:flatbuffers.Builder, schemaVersionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, schemaVersionOffset, 0);
}

static addComponentIds(builder:flatbuffers.Builder, componentIdsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, componentIdsOffset, 0);
}

static createComponentIdsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startComponentIdsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addActionIds(builder:flatbuffers.Builder, actionIdsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, actionIdsOffset, 0);
}

static createActionIdsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startActionIdsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addTokenIds(builder:flatbuffers.Builder, tokenIdsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, tokenIdsOffset, 0);
}

static createTokenIdsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startTokenIdsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addBindingIds(builder:flatbuffers.Builder, bindingIdsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, bindingIdsOffset, 0);
}

static createBindingIdsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startBindingIdsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addNodes(builder:flatbuffers.Builder, nodesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, nodesOffset, 0);
}

static createNodesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startNodesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addLayoutOps(builder:flatbuffers.Builder, layoutOpsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, layoutOpsOffset, 0);
}

static createLayoutOpsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startLayoutOpsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addDesignOps(builder:flatbuffers.Builder, designOpsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, designOpsOffset, 0);
}

static createDesignOpsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startDesignOpsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addBindings(builder:flatbuffers.Builder, bindingsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, bindingsOffset, 0);
}

static createBindingsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startBindingsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addDiagnostics(builder:flatbuffers.Builder, diagnosticsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, diagnosticsOffset, 0);
}

static createDiagnosticsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startDiagnosticsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addPropOps(builder:flatbuffers.Builder, propOpsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(10, propOpsOffset, 0);
}

static createPropOpsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startPropOpsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endRenderPack(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static finishRenderPackBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, 'RPK1');
}

static finishSizePrefixedRenderPackBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, 'RPK1', true);
}

static createRenderPack(builder:flatbuffers.Builder, schemaVersionOffset:flatbuffers.Offset, componentIdsOffset:flatbuffers.Offset, actionIdsOffset:flatbuffers.Offset, tokenIdsOffset:flatbuffers.Offset, bindingIdsOffset:flatbuffers.Offset, nodesOffset:flatbuffers.Offset, layoutOpsOffset:flatbuffers.Offset, designOpsOffset:flatbuffers.Offset, bindingsOffset:flatbuffers.Offset, diagnosticsOffset:flatbuffers.Offset, propOpsOffset:flatbuffers.Offset):flatbuffers.Offset {
  RenderPack.startRenderPack(builder);
  RenderPack.addSchemaVersion(builder, schemaVersionOffset);
  RenderPack.addComponentIds(builder, componentIdsOffset);
  RenderPack.addActionIds(builder, actionIdsOffset);
  RenderPack.addTokenIds(builder, tokenIdsOffset);
  RenderPack.addBindingIds(builder, bindingIdsOffset);
  RenderPack.addNodes(builder, nodesOffset);
  RenderPack.addLayoutOps(builder, layoutOpsOffset);
  RenderPack.addDesignOps(builder, designOpsOffset);
  RenderPack.addBindings(builder, bindingsOffset);
  RenderPack.addDiagnostics(builder, diagnosticsOffset);
  RenderPack.addPropOps(builder, propOpsOffset);
  return RenderPack.endRenderPack(builder);
}
}
